import React from 'react';
import styles from './ButtonContainer.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

/* Providers */
import { useProductContext } from '../../__providers__/ProductContext';

/* Components */
import { PurchaseButton } from './PurchaseButton/PurchaseButton';

interface ButtonContainerProps {}

export const ButtonContainer: React.FC<ButtonContainerProps> = ({}) => {
  const { t } = useTranslation();
  const { product } = useProductContext();

  return (
    <PurchaseButton>
      <span className={styles.content}>
        {product.unlockable
          ? tr(t, 'unlock').toUpperCase()
          : tr(t, 'pay').toUpperCase()}
      </span>
    </PurchaseButton>
  );
};
